import {generateCallback, implementCallback} from '../util/appCallback';
import util from '../util/common';

// 拍照或从手机相册中选图
export function chooseImage(option) {
    if (this.openPicturePlatform) {
        const globalMethodName = generateCallback(option, (img, state) => {
            const result = {
                code: -1,
                data: {}
            };
            if (~~state === 1) {
                result.code = 0;
                result.data = {
                    base64: `data:image/png;base64,${img}`
                };
            }
            return result;
        });
        const parsedType = parseInt(option.type);

        this.openPicturePlatform({
            width: option.width || 750,
            type: Number.isNaN(parsedType) ? 2 : parsedType,
            quality: option.quality || 0.8,
            orientation: typeof option.orientation === 'boolean' ? option.orientation : true,
            receiveJS: globalMethodName
        });
    }
}

// 预览图片
export function previewImage(option) {
    if (this.openNativeGallary) {
        this.openNativeGallary({
            index: option.index || 0,
            photoarray: option.photo || []
        });
        implementCallback({code: 0}, option);
    }
}

// 保存图片到相册
export function saveImageToPhotosAlbum(option) {
    if (this.saveImage && option.imgSrc) {
        let imgSrc = option.imgSrc;
        let type;
        const globalMethodName = generateCallback(option, (state, imgUrl) => {
            const result = {
                code: -1,
                data: {}
            };
            if (~~state === 1) {
                result.code = 0;
                result.data = {
                    imgUrl
                };
            }
            return result;
        });
        const regBase64 = /^data:image\/(gif|png|jpeg|jpg);base64,/;
        const regProtocol = /^http:|https:/;
        if (regProtocol.test(imgSrc)) {
            type = 1;
        } else if (regBase64.test(imgSrc)) {
            type = 0;
        } else {
            type = 1;
            imgSrc = util.formatURL(option.imgSrc);
        }
        this.saveImage({
            type: type,
            data: imgSrc,
            callback: globalMethodName
        });
    }
}

export default {
    chooseImage,
    previewImage,
    saveImageToPhotosAlbum
};
